module.exports = __webpack_public_path__ + "img/mdi_page-next-outline.83e839a8.svg";